import React from 'react';

const Footer = () => (
  <footer
    className="bg-bg-primary flex justify-between items-center px-10 py-4"
    style={{ borderTop: '0.5px solid #e0ddd8' }}
  >
    <span className="text-muted font-inter" style={{ fontSize: '11px', letterSpacing: '0.06em' }}>
      Karachi · New York · Toronto
    </span>
    <span className="text-muted font-inter" style={{ fontSize: '11px', letterSpacing: '0.06em' }}>
      © {new Date().getFullYear()} Manal Khan
    </span>
  </footer>
);

export default Footer;
